import { Compania } from 'src/app/shared/models/compania';
import { Component, OnInit, ViewChild, AfterViewInit, Inject } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config.service';
import { defaultValueOrRangeValidator, isMobile, isMobileXL, loadData, toFormData } from 'src/app/shared/utils/helpers';
import { forkJoin } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ItemParametro } from 'src/app/shared/models/itemparametro';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Pais } from 'src/app/shared/models/pais';
import { ProductosService } from 'src/app/shared/services/productos.service';
import { Router } from '@angular/router';
import { SalesOrg } from 'src/app/shared/models/salesOrg';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { StockPedido } from 'src/app/shared/models/stockPedido';
import { TablasService } from 'src/app/shared/services/tablas.service';

@Component({
  selector: 'app-stock-pedidos-dialog',
  templateUrl: './stock-pedidos-dialog.component.html'
})
export class StockPedidosDialogComponent implements OnInit, AfterViewInit {

  displayedColumns = ['nroPedido', 'tipoEntrega', 'cantidad'];
  dataSource = new MatTableDataSource<StockPedido>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private configService: ConfigService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<StockPedidosDialogComponent>,
    private fb: FormBuilder,
    private loggedService: LoggedService,
    private productosService: ProductosService,
    private router: Router,
    private sidenav: SidenavService,
    private snackBarService: SnackbarService,
    private tablasService: TablasService,

    @Inject(MAT_DIALOG_DATA) private data: any) {

    if (data.s != null) {
      this.dataSource.data = [];
      this.dataSource.data = data.s;
    }


  }

  public Etiquetas: {
    Buscar: string,
    SinRegistros: string,
  }



  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.sort.disableClear = true;

  }

  ngOnInit() {

    this.Etiquetas = {
      Buscar: this.configService.etiquetas.Buscar,
      SinRegistros: this.configService.etiquetas.SinRegistros
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  isMobileXL() {
    return isMobileXL();
  }

  isMobile() {
    return isMobile();
  }

}
